module.exports = __webpack_public_path__ + "img/apple-icon-180x180.2a8b14c7.png";